import { immerable } from 'immer';
export default class RenderedModuleModel {
  //@ts-expect-error has same name as the property...

  constructor({
    id,
    html = '',
    isBuiltIn = false,
    parentSelector = '',
    status = 'RENDERED',
    renderStartTime = 0,
    legacyWidgetHTML = []
  }) {
    this[immerable] = true;
    this.id = -1;
    this.status = 'RENDERED';
    this.html = '';
    this.renderStartTime = 0;
    this.isBuiltIn = false;
    this.parentSelector = '';
    this.legacyWidgetHTML = [];
    this.id = id;
    this.html = html;
    this.renderStartTime = 0;
    this.isBuiltIn = isBuiltIn;
    this.status = status;
    this.parentSelector = parentSelector;
    this.legacyWidgetHTML = legacyWidgetHTML;
    this.renderStartTime = renderStartTime;
  }
  static from(id, html = '', isBuiltIn = false, parentSelector = '', legacyWidgetHTML = [html]) {
    return new RenderedModuleModel({
      id,
      html,
      isBuiltIn,
      parentSelector,
      legacyWidgetHTML
    });
  }
  hasNoWrapper() {
    return this.parentSelector && this.parentSelector.length > 0;
  }
  isRendering() {
    return this.status === 'RENDERING';
  }
  isErrored() {
    return this.status === 'ERRORED';
  }
  isRendered() {
    return this.status === 'RENDERED';
  }
  getHasNoHtml() {
    return !this.html || this.html.trim().length === 0;
  }
  getHtml() {
    return this.html;
  }
  shouldShowPlaceholder() {
    return !this.isRendering() && this.getHasNoHtml();
  }
  withRendering() {
    this.status = 'RENDERING';
    this.renderStartTime = Date.now();
    return this;
  }
  withErrored() {
    this.status = 'ERRORED';
    this.html = '';
    return this;
  }
  withHtml(html) {
    this.html = html;
    this.status = 'RENDERED';
    this.renderStartTime = 0;
    return this;
  }
  forIndex(index) {
    this.html = this.legacyWidgetHTML[index];
    return this;
  }

  //@ts-expect-error has same name as the property...
  isBuiltIn() {
    return this.isBuiltIn;
  }
  createClone(id) {
    return new RenderedModuleModel({
      id,
      html: this.html,
      isBuiltIn: this.isBuiltIn,
      parentSelector: this.parentSelector,
      status: this.status,
      renderStartTime: this.renderStartTime,
      legacyWidgetHTML: [...this.legacyWidgetHTML]
    });
  }
}